import type { LessonType } from "@prisma/client";

const ACCENTS: Record<LessonType, string> = {
  READING: "border-l-4 border-reading",
  WRITING: "border-l-4 border-writing",
  SPEAKING: "border-l-4 border-speaking",
  DICTATION: "border-l-4 border-listening",
};

export function lessonTypeAccent(type: LessonType | "LISTENING" | "REVIEW"): string {
  if (type === "REVIEW") {
    return "border-l-4 border-lavender";
  }
  if (type === "LISTENING") {
    return "border-l-4 border-listening";
  }
  return ACCENTS[type];
}
